import * as tslib_1 from "tslib";
import React from 'react';
import Input from '../components/Input';
var InputContainer = /** @class */ (function (_super) {
    tslib_1.__extends(InputContainer, _super);
    function InputContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (e) {
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
            _this.setState({
                value: e.target.value,
            });
            if (_this.props.onInputValueChange) {
                _this.props.onInputValueChange(e);
            }
        };
        _this.onBlur = function (e) {
            if (e && e.stopPropagation) {
                e.stopPropagation();
            }
            else if (e) {
                e.stopPropagation = function () { return 0; };
            }
            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
            if (_this.props.onBlur) {
                _this.props.onBlur(e);
            }
        };
        _this.state = {
            value: props.value,
            valueFromProps: props.value,
        };
        return _this;
    }
    InputContainer.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.value !== prevState.valueFromProps) {
            return {
                value: nextProps.value,
                valueFromProps: nextProps.value,
            };
        }
        return null;
    };
    InputContainer.prototype.render = function () {
        return (React.createElement(Input, tslib_1.__assign({}, this.props, { value: this.state.value, onChange: this.onChange, onBlur: this.onBlur })));
    };
    return InputContainer;
}(React.Component));
export default InputContainer;
//# sourceMappingURL=InputContainer.js.map